import { render, staticRenderFns } from "./wTaxLibrary.vue?vue&type=template&id=1492c888&scoped=true&"
import script from "./wTaxLibrary.vue?vue&type=script&lang=js&"
export * from "./wTaxLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1492c888",
  null
  
)

export default component.exports